import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@radix-ui/themes/styles.css';
import { Theme } from '@radix-ui/themes';
import { testCacheFunctionality, testStudentSwitching, clearAllCache } from './utils/cacheTest';
import { validatePerformanceOptimizations, startPerformanceMonitoring, quickValidation } from './utils/validationScript';
import { apiService } from './services/api';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Theme
      accentColor="blue"
      grayColor="gray"
      radius="large"
      scaling="95%"
      className="custom-theme"
    >
      <App />
    </Theme>
  </React.StrictMode>
);

// Register service worker for caching and offline support
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
        registration.onupdatefound = () => {
          const installingWorker = registration.installing;
          if (installingWorker) {
            installingWorker.onstatechange = () => {
              if (installingWorker.state === 'installed') {
                if (navigator.serviceWorker.controller) {
                  alert('A new version is available. Please refresh the page.');
                }
              }
            };
          }
        };
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}

// Make testing functions globally available

// Expose functions globally for browser console testing
(window as any).testCacheFunctionality = testCacheFunctionality;
(window as any).testStudentSwitching = testStudentSwitching;
(window as any).clearAllCache = clearAllCache;
(window as any).apiService = apiService;
(window as any).validatePerformanceOptimizations = validatePerformanceOptimizations;
(window as any).startPerformanceMonitoring = startPerformanceMonitoring;
(window as any).quickValidation = quickValidation;

// Helper function to show available commands
(window as any).showTestCommands = () => {
  console.log('🧪 Available Testing Commands:');
  console.log('===============================');
  console.log('testCacheFunctionality() - Test basic caching');
  console.log('testStudentSwitching() - Test student switching cache');
  console.log('clearAllCache() - Clear all cached data');
  console.log('apiService.getCacheStatus() - Show cache status');
  console.log('validatePerformanceOptimizations() - Full performance validation');
  console.log('startPerformanceMonitoring() - Start real-time monitoring');
  console.log('quickValidation() - Quick performance check');
  console.log('showTestCommands() - Show this help');
  console.log('');
  console.log('🚀 Try: testCacheFunctionality() to test caching!');
};

console.log('🚀 Performance testing functions loaded!');
console.log('💡 Run showTestCommands() to see available functions');

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
